
export const themeData = {
    primary: '#0046e2',
    secondary: '#FE8C04',
    third: '#e0e0e0',
    success: '#28a745'
}
